import { useParams } from 'react-router-dom'
import { Table, useApiQuery, type Column } from 'grabbitbot-legacy-ui'
import { paymentClient } from '../../api'
import type { UsageFee } from 'grabbitbot-legacy-ui'

/** Equivalent of legacy `UsagefeeListComponent` (audit §3/§6 — usage-fee
 * billing list). `:usagefeeId` highlights that row. */
export function UsageFeeListPage() {
  const { usagefeeId } = useParams<{ usagefeeId?: string }>()
  const { data, loading, error } = useApiQuery(() => paymentClient.listUsageFees(), [])

  // `Data\Helper\UsageFee::export` (api.feesubscription.com) has no billing
  // period — a usage fee is a per-unit price, not a date range. The previous
  // columns (`amount`/`periodStart`/`periodEnd`) named fields the service
  // never sends (BubbleTicket c893af23); the real fields are `price` (per
  // `unit`, e.g. per API call) and `unitName`.
  const columns: Column<UsageFee>[] = [
    { key: 'name', label: 'Name', align: 'left' },
    { key: 'price', label: 'Price' },
    { key: 'currency', label: 'Currency' },
    { key: 'unitName', label: 'Per unit', align: 'left' },
  ]

  return (
    <div>
      <h1>Usage fees</h1>
      {loading && <p>Loading usage fees…</p>}
      {error && <p role="alert">Could not load usage fees.</p>}
      {data && (
        <Table
          columns={columns}
          rows={data}
          rowKey={(row, i) => row.id ?? i}
          rowClassName={(row) => (row.id === usagefeeId ? 'gbx-row--highlight' : undefined)}
        />
      )}
    </div>
  )
}
